

import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Table, Button } from "react-bootstrap";
import "./ImageDetail.css";

// 🔹 Import Images (No changes here, kept the same)
import mop1Detail from "../assets/Images/mopi11.jpg";
import mop2Detail from "../assets/Images/mopi22.jpg";
import mop3Detail from "../assets/Images/mopi33.jpg";
import mop4Detail from "../assets/Images/mopi44.jpg";

import cloth1Detail from "../assets/Images/cloth1detail.jpg";
import cloth2Detail from "../assets/Images/cloth2detail.jpg";
import cloth3Detail from "../assets/Images/cloth3detail.jpg";
import cloth4Detail from "../assets/Images/cloth4detail.jpg";

import handle1Detail from "../assets/Images/handle1detail.jpg";
import handle2Detail from "../assets/Images/handle2detail.jpg";
import handle3Detail from "../assets/Images/handle3detail.jpg";

import frame1Detail from "../assets/Images/frame1detail.jpg";
import frame2Detail from "../assets/Images/frame2detail.jpg";
import frame3Detail from "../assets/Images/frame3detail.jpg";

import misc1Detail from "../assets/Images/wiper11.jpg";
import misc2Detail from "../assets/Images/wiper22.jpg";
import misc3Detail from "../assets/Images/wiper33.jpg";


// 🔹 Table data (No changes here, kept the same)
const tableData = {
  1: { // Mops
    1: [
      { Article : "10.3501.03", Weight: "350g", packing : "21*17*13", pcs: 50, volume: "0.08" },
      { Article: "10.4001.03", Weight: "400g", packing: "17*13*12", pcs: 25, volume: "0.04" },
      { Article : "10.4501.03", Weight: "450g", packing: "17*17x12", pcs: 25, volume: "0.06" },
    ],
    2: [{ article: "10.3500.05", weight: "350g", packing: "21*17*13", pcs: 50, volume: "0.08" },
        { article: "10.4000.05", weight: "400g", packing: "17*13*12", pcs: 25, volume: "0.04" },
        { article: "10.4500.05", weight: "450g", packing: "17*17*12", pcs: 25, volume: "0.06" },
    ],

    3: [{ article: "102.3501.02", weight: "350g", packing: "21*17*13", pcs: 50, volume: "0.08" },
        { article: "102.4001.02", weight: "400g", packing: "17*13*12", pcs: 25, volume: "0.04" },
        { article: "102.4501.02", weight: "450g", packing: "17*17*12", pcs: 25, volume: "0.06" },
    ],
    4: [{ article: "10.3500.01", weight: "350g", packing: "21*17*13", pcs: 50, volume: "0.08" },
        { article: "10.4000.01", weight: "400g", packing: "17*13*12", pcs: 25, volume: "0.04" },
        { article: "10.4500.01", weight: "450g", packing: "17*17*12", pcs: 25, volume: "0.06" },
        { article: "10.5500.01", weight: "550g", packing: "17*17*12", pcs: 20, volume: "0.06" },
    ],
  },
  2: { // Cloths
    1: [{ article: "41.0031.05", size: "40*40", gsm: 320, pcs: 200, volume: "0.07",packing:4913 }], // Changed packing to match image
    2: [{ article: "99.2525.MC", size: "25*25",  pcs: 200, volume: "0.03", packing :12.5*12.5*12   },
        { article: "99.4050.MC", size: "40*50",  pcs: 200, volume: "0.05",  packing :17*17*10   },
        { article: "99.4060.MC", size: "40*60", pcs: 200, volume: "0.06",  packing :17*17*12     },
    ],
    3: [{ article: "18.1503.02", packing:17*17*8, pcs: 2, volume: "0.04" }],
    4: [{ article: "CT3045.01",size:30*45, packing:18.5*12*10, pcs: 120, volume: "0.04" },
        { article: "CT3060.01",size:30*45, packing:26*12*10, pcs: 125, volume: "0.05" },
    ],
  },
  3: { // Handles
    1: [{ article: "ALH140.03", size: "140", packing: "55.50*5.50*5.50", pcs: 25, volume: "0.03" },
        { article: "ALH150.03", size: "150", packing: "59.50*5.50*5.50", pcs: 25, volume: "0.03" },
        { article: "ALH160.03", size: "160", packing: "63.50*5.50*5.50", pcs: 25, volume: "0.03" },
    ],
    2: [{ article: "ICPH140.02", size : "140",packing: "55.50*5.50*5.50", pcs: 25, volume: "0.03" },
        { article: "ICPH150.02", size : "150",packing: "59.50*5.50*5.50", pcs: 25, volume: "0.03" },
        { article: "ICPH160.02", size : "160",packing: "63.50*5.50*5.50", pcs: 25, volume: "0.03" },
    ],
    3: [{ article: "35.1702.03", size : "90-160",packing: "37*10.5*4.5", pcs: 10, volume: "0.03" },
        { article: "35.1703.04", size : "60-110",packing: "36.5*2.75*2.75", pcs: 10, volume: "0.05" },
    ],
  },
  4: { // Frames
    1: [{ article: "31.4000.07F", size : "40",packing: "16*12*4", pcs: 10, volume: "0.01" },
        { article: "31.6000.07F", size : "60",packing: "24*12*4", pcs: 10, volume: "0.02" },
        { article: "31.8000.07F", size : "80",packing: "32*12*4", pcs: 10, volume: "0.03" },
        { article: "31.4000.06F", size : "40",packing: "16*12*4", pcs: 10, volume: "0.01" },
        { article: "31.6000.06F", size : "60",packing: "24*12*4", pcs: 10, volume: "0.02" },
        { article: "31.8000.06F", size : "80",packing: "32*12*4", pcs: 10, volume: "0.03" },
    ],
    2: [{ article: "31.0401.01", size: "40", pcs: 25, volume: "0.04", packing:"17*12*12" },
        { article: "31.0402.01", size: "40", pcs: 25, volume: "0.04" , packing :"17*12*12" },
    ],
    3: [{ article: "32.0001.04", weight: "80", pcs: 100, volume: "0.06",packing:"17*17*12" }],
  },
  5: { // Misc
    1: [{ article: "19.1505.14", size: "15", pcs: 25, volume: "0.07" , packing :"17*17*14" },
        { article: "19.1705.14", size: "17", pcs: 20, volume: "0.06" , packing :"17*17*12" },
    ],
    2: [{ article: "CMG.8001.20",  pcs: 1, volume: "0.004" , packing :"34.5*4.5*1.5" },
        { article: "LP.8002.20",  pcs: 1, volume: "0.004" , packing :"17*17*12" },
    ],
    3: [{ article: "19.1502.01", size:"15", pcs: 25, volume: "0.07" , packing :"17*17*14" },
        { article: "19.1702.20", size:"17" , pcs: 20, volume: "0.06" , packing :"17*17*12" },
    ],
  }
};

// 🔹 Image + Text data (No changes here, kept the same)
const detailsData = {
  1: [
    { id: 1, image: mop1Detail, text: "This is Mop Category 1 detail description." },
    { id: 2, image: mop2Detail, text: "This is Mop Category 2 detail description." },
    { id: 3, image: mop3Detail, text: "This is Mop Category 3 detail description." },
    { id: 4, image: mop4Detail, text: "This is Mop Category 4 detail description." },
  ],
  2: [
    { id: 1, image: cloth1Detail, text: "Cloth Category 1 detail description." },
    { id: 2, image: cloth2Detail, text: "Cloth Category 2 detail description." },
    { id: 3, image: cloth3Detail, text: "Cloth Category 3 detail description." },
    { id: 4, image: cloth4Detail, text: "Cloth Category 4 detail description." },
  ],
  3: [
    { id: 1, image: handle1Detail, text: "Handle Category 1 detail description." },
    { id: 2, image: handle2Detail, text: "Handle Category 2 detail description." },
    { id: 3, image: handle3Detail, text: "Handle Category 3 detail description." },
  ],
  4: [
    { id: 1, image: frame1Detail, text: "Frame Category 1 detail description." },
    { id: 2, image: frame2Detail, text: "Frame Category 2 detail description." },
    { id: 3, image: frame3Detail, text: "Frame Category 3 detail description." },
  ],
  5: [
    { id: 1, image: misc1Detail, text: "Misc Category 1 detail description." },
    { id: 2, image: misc2Detail, text: "Misc Category 2 detail description." },
    { id: 3, image: misc3Detail, text: "Misc Category 3 detail description." },
  ],
};

const ImageDetail = () => {
  const { id, imgId } = useParams();
  const navigate = useNavigate();

  const item = detailsData[id]?.find((d) => d.id === parseInt(imgId));
  const table = tableData[id]?.[imgId];

  if (!item) return <p className="text-center">No details found.</p>;

  // JSX Structure changed to apply custom CSS classes
  return (
    // 1. Main Wrapper/Container
    <Container className="detail-wrapper"> 
      {/* 2. Flex Layout - Replaces Row/Col for split card look */}
      <div className="detail-content"> 
        
        {/* 3. Left Side: Image Card with Hover/Zoom effect */}
        <div className="image-card">
          <img 
            src={item.image} 
            alt="Product detail" 
            className="detail-image" // 4. Image Class
          />
          {/* 5. Description Text */}
          <p className="detail-text">
             {item.text}
          </p>
        </div>

        {/* 6. Right Side: Table Card with Lift effect */}
        <div className="table-card">
          {table && (
            // 7. Custom Table Class
            <Table responsive className="table">
              <thead>
                <tr>
                  {Object.keys(table[0]).map((key, i) => (
                    // Convert key to UPPERCASE for professional look
                    <th key={i}>{key.toUpperCase()}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {table.map((row, i) => (
                  <tr key={i}>
                    {Object.values(row).map((val, j) => (
                      <td key={j}>{val}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </div>
      </div>
      
      {/* 8. Back Button (outside the flex content for full-width centering) */}
      <Button onClick={() => navigate(-1)} className="back-btn">
        &larr; Back
      </Button>
    </Container>
  );
};

export default ImageDetail;